import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import Cookies from 'js-cookie';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './Components/styles.css'; 
import ScrollToTop from './Components/ScrollToTop';
import DraggableBot from './Components/DraggableBot';

let blockedRedirectInProgress = false;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const blocked =
      error?.response?.status === 403 &&
      error?.response?.data?.error === 'ACCOUNT_BLOCKED';

    if (blocked && !blockedRedirectInProgress) {
      blockedRedirectInProgress = true;
      const cookieConsent = localStorage.getItem('bidit.cookieConsent');

      Cookies.remove('favids');
      Cookies.remove('token');
      Cookies.remove('name');
      Cookies.remove('last_name');
      Cookies.remove('id');
      Cookies.remove('username');
      Cookies.remove('email');
      Cookies.remove('phone');
      Cookies.remove('adminId');
      Cookies.remove('admintoken');
      localStorage.clear();

      if (cookieConsent) {
        localStorage.setItem('bidit.cookieConsent', cookieConsent);
      }

      window.alert('החשבון שלך חסום. לא ניתן לבצע פעולות באתר.');
      window.location.replace('/signin?blocked=1');
    }

    return Promise.reject(error);
  }
);


const root = ReactDOM.createRoot(document.getElementById('root'));
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}
root.render(
  <BrowserRouter>
    <GoogleOAuthProvider clientId="81632918386-v50hdm1gfa274voblqra5i5kl5len7tt.apps.googleusercontent.com">
      <App />
      <DraggableBot />
    </GoogleOAuthProvider>
  </BrowserRouter>
);

// ?? ����� �� service workers ������ ������
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister().then(() => {
        console.log('? Service worker unregistered');
      });
    }
  });
}
